import { Component, ViewChild, OnInit } from '@angular/core';
import {  Slides, ModalController } from 'ionic-angular';
import { LotteryDashboardService, gameType, ConfigService, SharedService, BannerSharedService, gametype, ThirdPartyService } from 'baseline-lib';
import { NavController } from 'ionic-angular';
import { Global } from '../../../global/global';
import { LotteryDetailPage } from '../lottery-detail/lottery-detail';
import { WebviewpagesPage } from '../../shared/webviewpages/webviewpages';


/**
 * Generated class for the HomeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'lottery-dashboard',
  templateUrl: 'lottery-dashboard.html'
})

export class LotteryDashboardComponent implements OnInit{
 
  @ViewChild('slides') slides: Slides;
  @ViewChild('lotteryTypeSlides') lotteryTypeSlides: Slides;
  private slideNumber: number = 0;
  httplink:string;

  constructor(public _lotteryDashboardService: LotteryDashboardService, public _configService: ConfigService,
    public globalData:Global,public navCtrl: NavController,
    public _sharedService:SharedService,private _bannerSharedService: BannerSharedService,
    public modalCtrl : ModalController,private _thirdPartyService : ThirdPartyService) {
     var gamety = new gametype();
     gamety.gtid = 1;
     gamety.gtn ='Lottery';
     gamety.url ='lottery';
     this._sharedService.selectedGameType = gamety;
  }

  ngOnInit(): void {
    this._lotteryDashboardService.getRecentEvents(gameType.lotto);    
    this._bannerSharedService.getBannerLists(1); 
  }
 
  slideLeft()
  {
    this.lotteryTypeSlides.slidePrev();
    if(this.slideNumber == 0)
    {
      this.lotteryTypeSlides.slideTo(this._lotteryDashboardService.dashboardObj.uniquegamename.length - 1);
    }
    if (this.slideNumber != 0) 
    {
      this.slideNumber = this.slideNumber - 1;
    }
    else
    {
      this.slideNumber = this._lotteryDashboardService.dashboardObj.uniquegamename.length - 1;
    }
    let gstid = this._lotteryDashboardService.dashboardObj.uniquegamename[this.slideNumber].gstid;
    this.gameclick(this._lotteryDashboardService.dashboardObj.uniquegamename[this.slideNumber]);    
  }

  slideRight()
  {
    this.lotteryTypeSlides.slideNext();
    if(this.slideNumber == this._lotteryDashboardService.dashboardObj.uniquegamename.length - 1)
    {
      this.lotteryTypeSlides.slideTo(this._lotteryDashboardService.dashboardObj.uniquegamename.indexOf(0));
    }
    if (this.slideNumber != this._lotteryDashboardService.dashboardObj.uniquegamename.length - 1)
    {
      this.slideNumber = this.slideNumber + 1;
    }
    else 
    {
      this.slideNumber = 0;
    }
    let gstid = this._lotteryDashboardService.dashboardObj.uniquegamename[this.slideNumber].gstid;
    this.gameclick(this._lotteryDashboardService.dashboardObj.uniquegamename[this.slideNumber]);
  }

  gameclick(games) 
  {
    this._lotteryDashboardService.game = games.gstid;
    if (games.isRapid)
    {
      this._lotteryDashboardService.loadRapidGameDraws();
    }
  }

  navigateTohttp(httplink) 
  {    
    let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: httplink });
    profileModal.present();
  }

  playNowButtonClicked(game_id:any)
  {
     this.navCtrl.push(LotteryDetailPage, {"game_id":game_id });
    //this.navCtrl.push('page-lottery-detail', {'game_id': game_id});

  }

  displayLottorace(){
    this._thirdPartyService.evaluateThirdPartyGame(7).subscribe(
      data=>
      {
        if(data)
        {              
          this.httplink = this._thirdPartyService.selectedGame.bindingUrl;
          let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this.httplink });
          profileModal.present();
        }            
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/lottery/lottery-dashboard/lottery-dashboard.ts